import { useQuery } from '@tanstack/react-query';
import { getOrgTitles } from '@/api/Terminal/OrgTitle';
import type { GetOrgTitlesServiceRes } from '@/api/Terminal/OrgTitle/types';
import { ReactQueryKey } from '@/constants/ReactQueryKeys';
import type { QueryParamsInterface } from '@/types/Shared';

interface UseOrgTitlesProps {
  params?: QueryParamsInterface;
  enabled?: boolean;
}

export const useOrgTitles = ({ params, enabled = true }: UseOrgTitlesProps) => {
  return useQuery<GetOrgTitlesServiceRes>({
    queryKey: [ReactQueryKey.GET_ORG_TITLES, params],
    queryFn: () => getOrgTitles({ order: 'asc', orderBy: 'name', ...params }),
    keepPreviousData: true,
    staleTime: 30000,
    enabled,
  });
};

export const useTitleById = (id?: number) => {
  const accountTitles = useOrgTitles({});

  const matchedTitle = accountTitles?.data?.data?.find((title) => title.id === id);

  const getTitle = (id: number) => {
    const matchedTitle = accountTitles?.data?.data?.find((title) => title.id === id);
    return matchedTitle;
  };

  return { matchedTitle, getTitle };
};

export const useTitleByName = (name?: string) => {
  const accountTitles = useOrgTitles({});

  const matchedTitle = accountTitles?.data?.data?.find((title) => title.name === name);

  const getTitle = (name: string) => {
    const matchedTitle = accountTitles?.data?.data?.find((title) => title.name === name.trim());
    return matchedTitle;
  };

  return { matchedTitle, getTitle };
};
